require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./yamhill-county-pretrial-justice.json") })
        }
      }, "path---yamhill-county-pretrial-justice");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---yamhill-county-pretrial-justice!./.cache/json/yamhill-county-pretrial-justice.json
// module id = 1068
// module chunks = 231608221292675